
import React from "react";
import { Input } from "@/components/ui/input";
import { Filter } from "lucide-react";

interface TerraceSearchFilterProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  totalCount: number;
}

const TerraceSearchFilter = ({ searchTerm, onSearchChange, totalCount }: TerraceSearchFilterProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
      <div className="w-full sm:w-80">
        <Input
          placeholder="Search terraces..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <div className="flex gap-2 items-center">
        <Filter className="h-4 w-4 text-gray-500" />
        <span className="text-sm text-gray-600">Total: {totalCount}</span>
      </div>
    </div>
  );
};

export default TerraceSearchFilter;
